module.exports = __webpack_public_path__ + "img/KR.bed07d15.svg";